import { render } from "./AutoDiscount.vue?vue&type=template&id=24d8035c&scoped=true"
import script from "./AutoDiscount.vue?vue&type=script&lang=js"
export * from "./AutoDiscount.vue?vue&type=script&lang=js"

import "./AutoDiscount.vue?vue&type=style&index=0&id=24d8035c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d8035c"]])

export default __exports__